/* @ngdoc object
 * @name guestlists
 * @description
 *
 */
angular
    .module('festzelt-os.modules.bo', [
        'ui.router',
        'festzelt-os.components',
        'festzelt-os.modules.bo.options',
        'festzelt-os.modules.bo.objects',
        'festzelt-os.modules.bo.option-links'
    ]);

// Routes
require('./bo-routes');

// Sub Modules
require('./objects/module');
require('./options/module');
require('./option-links/module');

// Components
require('./components/meta-list/component');
require('./components/meta-editor/component');
require('./components/al-bo-preview/component');
require('./components/al-bo-selector/component');



// WEBPACK FOOTER //
// ./src/app/modules/bo/bo-module.js